import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../context/authFirebase';
import { doc, getDoc, getDocs, collection, query, orderBy, where, limit } from 'firebase/firestore';

export default function Events() {
  const { id } = useParams();
  const [events, setEvents]           = useState(null);
  const [otherEvents, setOtherEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const docSnap = await getDoc(doc(db, 'Post', id));
        if (docSnap.exists()) setEvents(docSnap.data());

        const otherSnap = await getDocs(
          query(collection(db, 'Post'), where('category', '==', 'events'), orderBy('timeStamp', 'desc'), limit(3))
        );
        setOtherEvents(otherSnap.docs.map(d => ({ ...d.data(), id: d.id })).filter(p => p.id !== id));
      } catch (error) {
        console.error('Error fetching post:', error);
      }
    };
    fetchEvents();
  }, [id]);

  useEffect(() => {
    document.title = "EIT Ghana Limited - Events";
  }, []);

  if (!events) return (
    <div className="pt-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-5 lg:px-20 py-20 text-center">
        <h1 className="text-2xl font-bold text-blueblack">Event post not found.</h1>
      </div>
    </div>
  );

  return (
    <div className="pt-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-5 lg:px-20 py-8">
        <div className="lg:flex gap-6">

          {/* ── MAIN CONTENT ── */}
          <div className="lg:w-3/4 flex flex-col gap-5">
            <div className="bg-white rounded-3xl overflow-hidden shadow-sm">
              <img
                src={events.file}
                className="w-full lg:h-80 object-cover"
                alt={events.title}
              />
              <div className="p-8">
                <h1 className="text-2xl lg:text-3xl font-bold text-blueblack mb-4 leading-tight">{events.title}</h1>
                <div
                  className="text-gray-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: events.body }}
                />
              </div>
            </div>
          </div>

          {/* ── SIDEBAR ── */}
          <aside className="lg:w-1/4 flex flex-col gap-4 mt-6 lg:mt-0">
            <h3 className="text-xs font-bold uppercase tracking-widest text-gray-400">Other Events</h3>
            {otherEvents.map((post) => (
              <div key={post.id} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                <img
                  src={post.file}
                  className="w-full h-32 object-cover hidden lg:block"
                  alt={post.title}
                />
                <div className="p-4 flex flex-col gap-2">
                  <Link to={`/events/${post.id}`}>
                    <h3 className="font-bold text-blueblack hover:text-seablue transition-colors text-sm leading-snug">
                      {post.title}
                    </h3>
                  </Link>
                  <div
                    dangerouslySetInnerHTML={{ __html: post.body }}
                    className="text-gray-400 text-xs line-clamp-2 leading-relaxed"
                  />
                  <Link to={`/events/${post.id}`}>
                    <button className="px-4 py-1.5 bg-blueblack text-white text-xs font-semibold rounded-full hover:bg-seablue transition-all duration-300 mt-1">
                      Read More
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </aside>

        </div>
      </div>
    </div>
  );
}
